<script setup lang="ts">
import { useToast } from '~/composables/toast'
import TroodonToast from '~/components/troodon/toast.vue'

// グローバルな toast 表示。app.vue に1つだけ設置し、useToast().show() で表示する。
const { message, visible, duration, type, seq, hide } = useToast()
</script>

<template>
  <div class="c-toast-view" role="status" aria-live="polite">
    <TroodonToast v-if="visible" :key="seq" :type="type" :timeout="duration" @close="hide">{{
      message
    }}</TroodonToast>
  </div>
</template>

<style scoped lang="scss">
.c-toast-view {
  position: fixed;
  right: 16px;
  bottom: 12px;
  left: 16px;
  z-index: 300;
  display: flex;
  justify-content: center;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
}

@media (max-width: 600px) {
  :global(body.has-globalnav .c-toast-view) {
    bottom: calc(89px + 12px);
  }
}
</style>
